/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Query_Keys } from "../../../lib/queryKeys";
import { mergeQueryKeys, getBaseQueryKey } from "../utils/queryKeyHelpers";

const adminRefreshKeys = mergeQueryKeys(
  getBaseQueryKey(Query_Keys.admins),
  getBaseQueryKey(Query_Keys.admin_user_dropdown)
);

export const adminMutationKeyGroups = {
  create: adminRefreshKeys,
  update: adminRefreshKeys,
  delete: adminRefreshKeys,
  toggleStatus: [getBaseQueryKey(Query_Keys.admins)]
};
